import { z } from "zod";

export const TASK_DESCRIPTION_MAX = 2000;

export const TaskStatus = z.enum(["todo", "in_progress", "waiting", "done", "canceled"]);
export type TaskStatus = z.infer<typeof TaskStatus>;

/** Statuses an ordinary edit may set; cancellation and reopening are explicit transitions. */
export const EditableTaskStatus = TaskStatus.exclude(["canceled"]);
export type EditableTaskStatus = z.infer<typeof EditableTaskStatus>;

export const TASK_CANCELLATION_REASON_MAX = 2000;

/**
 * Statuses that count as still open — a task in any of these is awaiting work.
 * A parked (`waiting`) task keeps holding its one-open-per-type slot, so
 * returning it to `todo` can never collide with a duplicate opened meanwhile.
 */
export const OPEN_TASK_STATUSES: readonly TaskStatus[] = ["todo", "in_progress", "waiting"];

export const TaskPriority = z.enum(["low", "medium", "high", "critical"]);
export type TaskPriority = z.infer<typeof TaskPriority>;

/** Every task carries a priority; creators that omit one land here. */
export const DEFAULT_TASK_PRIORITY: TaskPriority = "medium";

export const TaskContextType = z.enum(["case", "client"]);
